// Import Vue
import Vue from 'vue';

// Import Vuex
import Vuex from 'vuex';

// Store
import Store from '../../vue/Store';

// Components
import Recipes from '../../vue/Recipes';

import Search from '../../vue/Search';

import Filters from '../../vue/Filters';

import VueSharelinks from 'vue-sharelinks';

Vue.use(Vuex);

// Assign to variable
const store = new Vuex.Store(Store);

export default () => {
  new Vue({
    store: store,
    el: '#recipes',
    components: {
      Recipes,
      Search,
      Filters,
      VueSharelinks
    }
  });
};
